import { Box } from '@chakra-ui/react';

import { ADMIN_ROLES_MAP_ORDER } from 'constants/ProjectConstants';
import { makeCommaSeparatedString } from 'constants/helper';

import CellContent from './components/CellContent';
import { TABLE_COLUMNS_DISPLAYNAME } from './constants';

export const returnAdminAccessesString = (accessesArray, userRoleMap) => {
  if (Array.isArray(accessesArray) && accessesArray.length) {
    // have to sort on FE because BE isn't sending sorted array

    const sortedAdminAccess = accessesArray
      .map((access) => ({ access, order: ADMIN_ROLES_MAP_ORDER[access]?.order }))
      .filter(({ order }) => order !== undefined)
      .sort((a, b) => a.order - b.order);
    const accessesLabelArray = sortedAdminAccess.map(({ access }) => userRoleMap[access]).filter((access) => access);
    return makeCommaSeparatedString(accessesLabelArray);
  }
  return null;
};

export const getCellValue = ({ columnKey, columnName, cellData, userRoleMap = null }) => {
  switch (columnName) {
    case TABLE_COLUMNS_DISPLAYNAME.employeeAccesses: {
      const { employeeAccesses } = cellData;
      const accessNames = returnAdminAccessesString(employeeAccesses, userRoleMap);
      return accessNames || '';
    }

    default: {
      return cellData?.metadata?.[columnKey] ?? '';
    }
  }
};

export const employeeCellRenderer = (params) => {
  const cellInfo = params.colDef;
  const { displayName, colId } = cellInfo;
  const cellData = params.data;
  return (
    <Box>
      <CellContent columnName={displayName} cellData={cellData} columnKey={colId} />
    </Box>
  );
};
